/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const EnvelopeOpen = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M22.391 9.11L23 9.58537V22.9514H1V9.58537L1.608 9.11L2.755 10.117L12 18.4424L21.247 10.119L22.391 9.11ZM21.5 11.9094L12 20.4604L2.5 11.9094V21.4504H21.5V11.9094ZM12 1L21.188 8.171L20.041 9.178L12 2.9024L3.958 9.178L2.811 8.171L12 1Z"
                        fill={color}
                    />
                </svg>
        );
    };
